import { Checkbox } from '@ordr-as/umami-react/checkbox';
import type { FC } from 'react';
import type { CartOrderLineComponent } from '../../../../../../../types/cart';

interface Props {
  component: CartOrderLineComponent;
  courseName: string;
  isSelected: boolean;
  onToggle: (selected: boolean) => void;
}

const SelectableComponentRow: FC<Props> = ({ component, courseName, isSelected, onToggle }) => {
  const label =
    component.unitQuantity && component.unitQuantity > 1
      ? `${component.unitQuantity}\u00D7 ${component.name}`
      : component.name;

  return (
    <Checkbox
      className="flex items-center justify-between py-3 border-b-grey-lightest border-b"
      isSelected={isSelected}
      onChange={onToggle}
    >
      <span className="flex flex-1 items-center justify-between">
        <span>{label}</span>
        <span className="text-small text-grey-dark">{courseName}</span>
      </span>
    </Checkbox>
  );
};

export default SelectableComponentRow;
